module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['social-bar']
  }, [_c('ul', _vm._l((_vm.services), function(service, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": service.url(_vm.url, _vm.title()),
        "title": _vm.firstLetterCapital(service.icon)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.popup(service.url(_vm.url, _vm.title()))
        }
      }
    }, [_c('i', {
      class: ['mdi', ("mdi-" + (service.icon))],
      style: ({
        fontSize: (_vm.fontSize + "em")
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a3cda5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demo-components/social-bar.vue
// module id = 51
// module chunks = 0